module.exports = __webpack_public_path__ + "141d4a85/img/archive-icon.0a6a9de3.svg";